import clsx from "clsx";

import useTranslation from "hooks/useTranslation";
import { TriangleDanger, ArrowLongComponent } from "assets/icons";
import { PACKAGE_UPGRADE_LINK } from "utils/constants";
import Alert from "../Alert";
import { getNotifMsg } from "utils/message";
import styles from "../styles.module.scss";

function ExpirePackageBanner() {
  const { getAppLocale, getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const locale = getAppLocale();

  const text = getNotifMsg("EXPIRE_PACKAGE_ALERT", locale);

  const renderActionBtn = (
    <a
      className={clsx([styles.action_btn, styles.action_btn__primary])}
      rel="noreferrer"
      target="_blank"
      href={PACKAGE_UPGRADE_LINK}
    >
      <ArrowLongComponent className={styles.action_btn__icon} />
      {t("RENEW")}
    </a>
  );

  return (
    <Alert
      type="expire"
      text={text}
      icon={<TriangleDanger />}
      actionBtn={renderActionBtn}
    />
  );
}

export default ExpirePackageBanner;
